module.exports = __webpack_public_path__ + "static/20-7b84d88c3a37d607ab0892098b5cc984.jpg";